// Fechas del inbox de WhatsApp, en español y en la hora del navegador. A mano y no con moment:
// el idioma de moment depende de que otra pantalla lo haya configurado antes.

const DIAS = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
const MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto",
    "septiembre", "octubre", "noviembre", "diciembre"];

const dosDigitos = (n) => String(n).padStart(2, "0");

// "2026-10-03": para saber si dos mensajes son del mismo día.
export const claveDia = (iso) => {
    if (!iso) return null;
    const d = new Date(iso);
    return `${d.getFullYear()}-${dosDigitos(d.getMonth() + 1)}-${dosDigitos(d.getDate())}`;
};

export const hora = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    return `${dosDigitos(d.getHours())}:${dosDigitos(d.getMinutes())}`;
};

// El separador entre días, como en WhatsApp: "Hoy", "Ayer", "lunes 29 de septiembre".
export const etiquetaDia = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    const hoy = new Date();
    const ayer = new Date();
    ayer.setDate(hoy.getDate() - 1);

    if (claveDia(d.toISOString()) === claveDia(hoy.toISOString())) return "Hoy";
    if (claveDia(d.toISOString()) === claveDia(ayer.toISOString())) return "Ayer";

    const base = `${DIAS[d.getDay()]} ${d.getDate()} de ${MESES[d.getMonth()]}`;
    return d.getFullYear() === hoy.getFullYear() ? base : `${base} de ${d.getFullYear()}`;
};

// "viernes 3 de octubre, 18:12": para el detalle de cada mensaje.
export const fechaHora = (iso) => (iso ? `${etiquetaDia(iso)}, ${hora(iso)}` : "");
